import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  FaTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";

const logoUrl = (
  <img src="/assets/images/logo/cus-lightv2.png" alt="Footer logo" />
);

const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/" },
  { Social: <FaTwitter />, link: "https://twitter.com/" },
];

const Footer = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";
  return (
    <React.Fragment>
      <footer className="footer-area footer-style-01 bg_color--6">
        <div className="footer-wrapper ptb--70">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                <div className="ft-text">
                  <div className="logo">
                    <Link to="/">{logoUrl}</Link>
                  </div>
                  <p>
                    © 2023 <Link to="/">CUS</Link>. Mohammed VI Polytechnic
                    University
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-xl-2 offset-xl-1 col-md-6 col-sm-6 col-12 mt_mobile--40">
                <div className="footer-link">
                  <h4>Quick Link</h4>
                  <ul className="ft-link">
                    <li>
                      <a href="/about">{isEnglish ? "About" : "À propos"}</a>
                    </li>
                    <li>
                      <a href="/team">{isEnglish ? "Team" : "Équipe"}</a>
                    </li>
                    <li>
                      <a href="/projects">
                        {isEnglish ? "Research Project" : "Projet de recherche"}
                      </a>
                    </li>
                    <li>
                      <a href="/news">
                        {isEnglish
                          ? "Collaboration et partenariatss"
                          : "Collaboration and Partnership	"}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt_md--40 mt_sm--40">
                <div className="footer-link">
                  <h4>Pages</h4>
                  <ul className="ft-link">
                    <li>
                      <a href="/educations">
                        {isEnglish
                          ? "Education & Outreach"
                          : "Éducation et diffusion"}
                      </a>
                    </li>
                    <li>
                      <a href="/publications">Publications</a>
                    </li>
                   

                    <li>
                      <a href="/contact">Contact</a>
                    </li>
                  </ul>
                </div>
              </div>
              
              <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt_md--40 mt_sm--40">
                <div className="footer-link">
                  <h4>Follow Us</h4>
                  <ul className="ft-link">
                    <li>
                      Email :{" "}
                      <a href="mailto:contact.cus@um6p.ma">
                        contact.cus@um6p.ma
                      </a>
                    </li>
                    <li>
                      Location : Lot 660, Hay Moulay Rachid, Ben Guerir 43150,
                      Morocco
                    </li>
                 
                  </ul>

                  <div className="social-share-inner mt--20">
                    <ul className="social-share social-style--2 d-flex justify-content-start liststyle">
                      {SocialShare.map((val, i) => (
                        <li key={i}>
                          <a href={`${val.link}`} target="_blank">
                            {val.Social}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};
export default Footer;
